import React, { FC, useMemo } from 'react';
import { CircularProgress } from '@material-ui/core';
import Button, { Themes as ButtonThemes } from 'ui/Button/Button';
import ModalWindow from '../ModalWindow/ModalWindow';
import { IWarningModalProps } from '../IModalProps';

import styles from './WarningModal.module.css';

import errorIcon from 'assets/icons/error.png';
import warningIcon from 'assets/icons/warning.png';

type Props = {
  noIcon?: boolean,
  showClose?: boolean,
  showCloseIcon?: boolean,
  submitting?: boolean,
}

const WarningModal: FC<IWarningModalProps & Props> = ({
  cancelName = 'Cancel',
  submitName,
  onClose,
  onSubmit,
  children,
  icon = 'warning',
  noIcon,
  submitting,
  ...modalProps
}) => {
  const iconImg = useMemo(() => (icon === 'error' ? errorIcon : warningIcon), [icon]);

  return (
    <ModalWindow onClose={onClose} {...modalProps}>
      <div className={styles.container}>
        {!noIcon && <img src={iconImg} alt="warning-icon" />}
        <span className={styles.message}>{children}</span>
        <div className={styles.buttonContainer}>
          <Button
            theme={submitName ? ButtonThemes.secondary : undefined}
            fullWidth
            className={styles.button}
            onClick={onClose}
            disabled={submitting}
          >
            {cancelName}
          </Button>
          {submitName && (
            <Button
              fullWidth
              className={styles.button}
              onClick={onSubmit}
              disabled={submitting}
            >
              {!submitting ? submitName : <CircularProgress size={20} color="inherit" />}
            </Button>
          )}
        </div>
      </div>
    </ModalWindow>
  );
};

export default WarningModal;
